var l = "object" == typeof self && self.self === self && self || "object" == typeof global && global.global === global && global || void 0,
    e = "undefined";

function o(e) {
  return l[e];
}

function f(e, o) {
  return l[e] = o, o;
}

function n(l) {
  f(l);
}

export { o as get, l as globalContext, n as remove, f as set, e as undef };